import { skipToken, useQuery } from "@tanstack/react-query";
import { getMerchantsFacilitiesPublicID } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { FacilityDetailDto } from "Infrastructure/Api/Api";

const FACILITY_QUERY_KEY = "FACILITY";

export const facilityKeys = {
  all: [FACILITY_QUERY_KEY] as const,
  byPublicId: (publicID?: string | null) =>
    [...facilityKeys.all, publicID] as const,
};

export const useFacilityQuery = (publicID?: string | null, enabled = true) =>
  useQuery<FacilityDetailDto>({
    queryKey: facilityKeys.byPublicId(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getMerchantsFacilitiesPublicID(publicID),
        )
      : skipToken,
    enabled: !!publicID && enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * MS_TIME.minute,
  });
